import { render, staticRenderFns } from "./Loggin.vue?vue&type=template&id=0a70b6a6&"
import script from "./Loggin.vue?vue&type=script&lang=js&"
export * from "./Loggin.vue?vue&type=script&lang=js&"
import style0 from "./Loggin.vue?vue&type=style&index=0&id=0a70b6a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports